import { Button, ButtonProps, darken, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';

export type SuccessButtonProps = ButtonProps & {
}

export function SuccessButton ({className, ...props}: SuccessButtonProps) {
    const cls = useStyles();

    return <Button variant="contained" {...props} className={clsx(cls.root, className)} />
}

const useStyles = makeStyles(theme => ({
    root : {
        color: 'white',
        backgroundColor: '#006400', //darkgreen

        '&:hover': {
            backgroundColor: darken('#006400', 0.2),
        },
    }
}));